import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  position: relative;
  width: 111px;
  .ant-picker {
    border: none;
    padding: 0;
    opacity: 0;
  }
  input {
    cursor: pointer;
    opacity: 0;
  }
  .ant-picker-suffix {
    display: none;
  }

  input::placeholder {
    color: ${colors.mainText};
    border-bottom: 1px dashed rgb(100, 104, 119);
  }

  .ant-picker-footer {
    display: none;
  }
`

export const ButtonText = styled.span`
  color: ${colors.mainText};
  border-bottom: 1px dashed rgb(100, 104, 119);
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
`
